import { Tag } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import type { StockSignal } from "shared/merchCatalog";

type StockBadgeProps = {
  signal: StockSignal;
  remaining: number;
  quantityInCart?: number;
};

/** Sold out, "Only N left" or "Going fast"; falls back to the in-cart count. */
export const StockBadge = ({
  signal,
  remaining,
  quantityInCart = 0,
}: StockBadgeProps) => {
  const { t } = useTranslation("booker", { keyPrefix: "MERCH_CATALOG" });

  if (quantityInCart > 0) {
    return (
      <Tag visual="primary" mode="dark" size="sm">
        {t("IN_CART", { count: quantityInCart })}
      </Tag>
    );
  }
  if (signal === "sold_out") {
    return (
      <Tag visual="warning" mode="dark" size="sm">
        {t("SOLD_OUT")}
      </Tag>
    );
  }
  if (signal === "last_few") {
    return (
      <Tag visual="destructive" mode="dark" size="sm">
        {t("ONLY_N_LEFT", { count: remaining })}
      </Tag>
    );
  }
  if (signal === "going_fast") {
    return (
      <Tag visual="accent.magenta" mode="dark" size="sm">
        {t("GOING_FAST")}
      </Tag>
    );
  }
  return null;
};
